"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";

type Props = {
  className?: string;
  color?: string;
};

const SearchIcon: FC<Props> = ({ className, color = "currentColor" }) => (
  <HugeiconsIcon
    icon={Search01Icon}
    className={className}
    color={color}
    strokeWidth={1.5}
  />
);

export default SearchIcon;
